import { render, staticRenderFns } from "./RealTimeTransCC.vue?vue&type=template&id=50552154&scoped=true"
import script from "./RealTimeTransCC.vue?vue&type=script&lang=js"
export * from "./RealTimeTransCC.vue?vue&type=script&lang=js"
import style0 from "./RealTimeTransCC.vue?vue&type=style&index=0&id=50552154&prod&scoped=true&lang=scss"
import style1 from "./RealTimeTransCC.vue?vue&type=style&index=1&id=50552154&prod&scope=true&lang=scss"
import style2 from "./RealTimeTransCC.vue?vue&type=style&index=2&id=50552154&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50552154",
  null
  
)

export default component.exports